module.exports = __webpack_public_path__ + "img/gp_main02_arrow.58ed667e.svg";